const updateFormStatus = (form) => {
	if (!form) return;
	const submitBtn = form.querySelector('.smf-button-control__control[data-action="complete"]');
	const smfAction = form.querySelector(".smf-action");
	if (!submitBtn || !smfAction) return;

	const privacyCheckbox = form.querySelector('input[name="checkbox-privacy[]"]');
	const isPrivacyUnchecked = privacyCheckbox ? !privacyCheckbox.checked : false;

	const hasEmailError = form.querySelector(".smf-item__controls .smf-error-messages") !== null;
	const hasFileError = form.querySelector(".smf-placeholder .smf-error-messages") !== null;

	const hasAnyError = hasEmailError || hasFileError || isPrivacyUnchecked;

	let summaryError = form.querySelector(".smf-form-summary-error");

	if (hasAnyError) {
		submitBtn.disabled = true;
		submitBtn.style.opacity = "0.5";
		submitBtn.style.cursor = "not-allowed";

		if (!summaryError) {
			summaryError = document.createElement("div");
			summaryError.className = "smf-error-messages smf-form-summary-error";
			summaryError.style.marginTop = "15px";
			summaryError.style.textAlign = "center";
			summaryError.style.fontWeight = "bold";
			summaryError.textContent = isPrivacyUnchecked ? "個人情報の取り扱いに同意してください。" : "メールアドレスまたは添付ファイルに不備があります。修正するまで送信できません。";
			smfAction.after(summaryError);
		} else {
			summaryError.textContent = isPrivacyUnchecked ? "個人情報の取り扱いに同意してください。" : "メールアドレスまたは添付ファイルに不備があります。修正するまで送信できません。";
		}
	} else {
		submitBtn.disabled = false;
		submitBtn.style.opacity = "";
		submitBtn.style.cursor = "";

		if (summaryError) {
			summaryError.remove();
		}
	}
};

// プライバシーポリシーのイベントを監視する専用バリデータ
export function initPrivacyValidator() {
	const form = document.querySelector(".snow-monkey-form");
	const privacyCheckbox = form?.querySelector('input[name="checkbox-privacy[]"]');

	if (!form || !privacyCheckbox) return;

	// SMF側の初期化スクリプトによるボタン状態の上書きを待ってから、強制的に初期ロックをかける
	setTimeout(() => {
		updateFormStatus(form);
	}, 200);

	// ユーザーのクリック操作を確実に捕捉してリアルタイムにボタン状態を更新
	privacyCheckbox.addEventListener("click", () => {
		setTimeout(() => {
			updateFormStatus(form);
		}, 10);
	});
}

export function initEmailValidator() {
	const form = document.querySelector(".snow-monkey-form");
	if (!form) return;

	const emailInput = form.querySelector('input[name="email"]');
	const confirmInput = form.querySelector('input[name="email_confirm"]');
	if (!emailInput || !confirmInput) return;

	const checkEmailMatching = () => {
		const textControl = confirmInput.closest(".smf-text-control");
		const itemControls = confirmInput.closest(".smf-item__controls");
		if (!textControl || !itemControls) return;

		const existingError = itemControls.querySelector(".smf-error-messages");
		if (existingError) {
			existingError.remove();
		}

		if (emailInput.value && confirmInput.value && emailInput.value !== confirmInput.value) {
			const errorDiv = document.createElement("div");
			errorDiv.className = "smf-error-messages";
			errorDiv.textContent = "メールアドレスが一致しません。もう一度ご確認ください。";
			textControl.after(errorDiv);
		}

		updateFormStatus(form);
	};

	confirmInput.addEventListener("blur", checkEmailMatching);
	emailInput.addEventListener("blur", checkEmailMatching);
	confirmInput.addEventListener("input", checkEmailMatching);
	emailInput.addEventListener("input", checkEmailMatching);
}

export function initFileValidator() {
	const form = document.querySelector(".snow-monkey-form");
	if (!form) return;

	const ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".heic"];
	const MAX_FILE_SIZE = 10 * 1024 * 1024;

	document.addEventListener("change", (event) => {
		if (event.target.name !== "file01" && event.target.name !== "file02") return;

		const fileInput = event.target;
		const fileControl = fileInput.closest(".smf-file-control");
		const parentPlaceholder = fileInput.closest(".smf-placeholder");
		if (!fileControl || !parentPlaceholder) return;

		const existingError = parentPlaceholder.querySelector(".smf-error-messages");
		if (existingError) {
			existingError.remove();
		}

		const file = fileInput.files[0];
		if (!file) {
			updateFormStatus(form);
			return;
		}

		const fileName = file.name.toLowerCase();
		const hasValidExtension = ALLOWED_EXTENSIONS.some((ext) => fileName.endsWith(ext));
		let errorMessage = "";

		if (!hasValidExtension) {
			errorMessage = "許可されていないファイル形式です。JPG、PNG、HEIC画像を選択してください。";
		} else if (file.size > MAX_FILE_SIZE) {
			errorMessage = "ファイルサイズが大きすぎます。10MB以下の画像を選択してください。";
		}

		if (errorMessage) {
			fileInput.value = "";

			const noFileSpan = fileControl.querySelector(".smf-file-control__filename--no-file");
			const hasFileSpan = fileControl.querySelector(".smf-file-control__filename--has-file");
			if (noFileSpan && hasFileSpan) {
				noFileSpan.style.display = "inline";
				hasFileSpan.style.display = "none";
				hasFileSpan.textContent = "";
			}

			const errorDiv = document.createElement("div");
			errorDiv.className = "smf-error-messages";
			errorDiv.textContent = errorMessage;
			fileControl.after(errorDiv);
		}

		updateFormStatus(form);
	});

	document.addEventListener("click", (event) => {
		if (!event.target.classList.contains("smf-file-control__clear")) return;

		const parentPlaceholder = event.target.closest(".smf-placeholder");
		if (!parentPlaceholder) return;

		const existingError = parentPlaceholder.querySelector(".smf-error-messages");
		if (existingError) {
			existingError.remove();
		}

		updateFormStatus(form);
	});
}

export function initFormRedirect() {
	document.addEventListener("smf.submit", (event) => {
		if (event.detail && event.detail.status === "complete") {
			window.location.replace("/thanks/");
		}
	});
}

export function initFilePreview() {
	document.addEventListener("change", (event) => {
		if (event.target.name !== "file01" && event.target.name !== "file02") return;

		const fileInput = event.target;
		const fileControl = fileInput.closest(".smf-file-control");
		if (!fileControl) return;

		const existingPreview = fileControl.parentNode.querySelector(".smf-file-preview");
		if (existingPreview) {
			// 💡 修正：未定義の既存エラー削除処理（タイポ）を安全に排除
			existingPreview.remove();
		}

		const file = fileInput.files[0];
		if (!file || !file.type.startsWith("image/")) return;

		const reader = new FileReader();
		reader.onload = (e) => {
			const previewContainer = document.createElement("div");
			previewContainer.className = "smf-file-preview";

			const img = document.createElement("img");
			img.src = e.target.result;

			previewContainer.appendChild(img);
			fileControl.after(previewContainer);
		};

		reader.readAsDataURL(file);
	});

	document.addEventListener("click", (event) => {
		if (!event.target.classList.contains("smf-file-control__clear")) return;

		const clearButton = event.target;
		const fileControl = clearButton.closest(".smf-file-control");
		if (!fileControl) return;

		const existingPreview = fileControl.parentNode.querySelector(".smf-file-preview");
		if (existingPreview) {
			existingPreview.remove();
		}
	});
}
